import styled from "styled-components";

export const CompareAvatarContainer = styled.div`
	width: 100%;

	button {
		margin-bottom: 20px;
	}
`;
